export default __webpack_public_path__ + "static/media/shopping-home.9474cb5f.svg";